var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.creditCardRequired,
          expression: "creditCardRequired"
        }
      ]
    },
    [
      _vm.stripe
        ? _c("StripePaymentInput", {
            ref: "StripePaymentElement",
            staticClass: "my-2",
            attrs: { stripe: _vm.stripe }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.stripe_error
        ? _c(
            "div",
            {
              attrs: {
                id: "cardErrorMessage",
                "data-test-id": "card-error-message"
              }
            },
            [_vm._v(_vm._s(_vm.stripe_error))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "AppModal",
        {
          ref: "modal",
          attrs: {
            id: "subscription-confirm-new-account-modal",
            staticDataBackdrop: true,
            hideClose: true,
            title: "Are you sure you want to create another account",
            action: _vm.trialDays
              ? `Yes, Start My ${_vm.trialDays}-Day Trial`
              : "Yes, Start My Subscription",
            "secondary-action": "No, login to Existing Account"
          },
          on: {
            cta: _vm.createSubscription,
            "secondary-cta": _vm.goToLoginWithExistingEmail
          }
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _vm._v("\n\t\t\t" + _vm._s(_vm.subheading) + "\n\t\t")
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }